@if (formControl()) {
<div class="graphql-checker form-group">
    <mat-form-field class="form-field">
        <input matInput [readonly]="meta().readonly" [placeholder]="meta().name"
            [formControl]="$any(formArray()?.at(arrayIndex() ?? 0) || formControl())">
        @if (formControl()?.value && !meta().readonly) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        @if (meta().info) {
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('pattern') && !formControl()?.hasError('required')) {
        <mat-error>
            GraphQL Type is invalid
        </mat-error>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            GraphQL Type can not be empty.
        </mat-error>
        }
        @if (formControl()?.hasError('async') && !formControl()?.hasError('required')) {
        <mat-error>
            Duplicate GraphQL Type found.
        </mat-error>
        }
        @if (formControl()?.errors?.form) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
